import { Application, TextureStyle , Graphics, Container, Ticker} from 'pixi.js'
import { preloadAssets } from './assets/assets'
import { Background } from './classes/Background';
import { loadSettings, settingValue, findSettingByID, settings } from './settings';

import { ViewportInstance } from './classes/ViewportInstance';

import { ColorReplaceFilter } from 'pixi-filters';
import { graphicsContainer, MenuGraphics } from './classes/MenuGraphics';
import { ViewportGraphics } from './classes/ViewportGraphic';
import { setHeadingWidths } from './main';
import { setPalette } from './palettes';
import { menu } from './screens/default';

export const app = new Application()
export const backgroundContainer = new Container();
export const mainContainer = new Container();
export const gearContainer = new Container();
export let menuGraphics: MenuGraphics;


export let background: Background;

export let viewportInstances: ViewportInstance[] = [];



backgroundContainer.zIndex = -1;
mainContainer.zIndex = 0;

gearContainer.zIndex = 2;

await preloadAssets(); //load images for sprites

TextureStyle.defaultOptions.scaleMode = 'nearest'; //linear or nearest
// TextureStyle.defaultOptions.scaleMode = 'linear';
TextureStyle.defaultOptions.wrapMode = 'repeat';
export let mobileView = (window.innerWidth <= window.innerHeight);
export const isTouchDevice = window.matchMedia('(pointer: coarse)').matches;

let widthLandscape = 680;
let widthPortrait = 400;

export function updateWidths(){
  widthLandscape = Math.max(400, settingValue(findSettingByID(44)) ?? 680) //set lower bound incase of saved low value
  widthPortrait = Math.max(200, settingValue(findSettingByID(45)) ?? 400)
}

export let fixedWidth = mobileView ? widthPortrait: widthLandscape;
let aspectRatio = window.innerHeight / window.innerWidth;
// const screenMult = window.innerHeight / fixedWidth;
let scale = window.innerWidth / fixedWidth;

app.stage.sortableChildren = true;

//make everything pixelated----surely there is a better way?
        const filter = new ColorReplaceFilter();
        filter.resolution = 1
        filter.targetColor = 0x000000;
        filter.originalColor = 0x000000;
        filter.tolerance = 0;
        app.stage.filters = [filter]

  filter.resolution = 1;

export function killBackground() {
  if (!background) return;
  backgroundContainer.removeChild(background)
  background.stripes.forEach(stripe => stripe.killTicker())
  background.destroy({children: true, texture: true})
}

export  function resetBackground() {

  killBackground(); //ensure starting fresh
  background = new Background();
  //if background is enabled
  if (settingValue(findSettingByID(39)) === 1) {
    backgroundContainer.addChild(background)
  }
  
}

export async function initPixi() {

  await loadSettings();

  await app.init({
    preference: 'webgl',
    width: fixedWidth,
    height: fixedWidth*aspectRatio,
    backgroundAlpha: 0,
    autoDensity: true,
    resolution: window.devicePixelRatio * scale
  })

  
  app.ticker.autoStart = true;
  Ticker.shared.autoStart = true;
  Ticker.system.autoStart = true;
  
  app.ticker.autoStart = true;
  app.ticker['_protected'] = true;
  Ticker.shared['_protected'] = true;

  //disabling touch effects on mobile
  app.canvas.style.touchAction = 'none';

  resetBackground();

  //event listeners
  window.addEventListener('resize', resizeCanvas);
  window.addEventListener('orientationchange', resizeCanvas);

  document.addEventListener(
    'touchmove',
    (e) => {
      if (!(e.target as HTMLElement).closest('.menu')) {
        e.preventDefault();
      }
    },
    { passive: false }
  );
  document.addEventListener('fullscreenchange', resizeCanvas);

  document.addEventListener('visibilitychange', (e) => {
    if (!document.hidden) resizeCanvas();
     e.stopImmediatePropagation()
  }, true);

  updateWidths()
  resizeCanvas(); //resize on startup

  //bug fixes for ios
  app.renderer.events.autoPreventDefault = false;
  setTimeout(() => {
    resizeCanvas();
  }, 100);
  
  app.stage.addChild(backgroundContainer)
  app.stage.addChild(gearContainer)

  // console.log("gear container",  gearContainer.width)
  // console.log("menuGraphics",  menuGraphics.width)
  // console.log("backgroundContainer container",  backgroundContainer.width)
  // console.log("backgroundContainer container",  backgroundContainer.width)

  function debugContainer(container: Container, color: number) {
    const g = new Graphics();
    app.ticker.add(() => {
        g.clear();
        const bounds = container.getBounds();
        const width = bounds.width;
        const height = bounds.height;
        g.rect(bounds.x, bounds.y, width, height)
         .stroke({ color, width: 2, alpha: 0.8 });
        g.rect(bounds.x+width/4, bounds.y+height/4, width-width/2, bounds.height-height/2)
         .stroke({ color, width: 1.5, alpha: 0.4 });
    });
    app.stage.addChild(g);
}

// debugContainer(mainContainer, 0xff0000);
// debugContainer(gearContainer, 0x00ff00);
// debugContainer(backgroundContainer, 0x0000ff);
// debugContainer(app.stage, 0x00ffff)

  return app
}

export function resetMenuGraphics() {


  //kill stage
  if (menuGraphics !== undefined) {
    //kill all children, then self
    Array.from(graphicsContainer.children).forEach(child => {
      if (child instanceof ViewportGraphics) {
        child.killTicker()
        child.destroy();
      }
    })
    Array.from(gearContainer.children).forEach(child => {
      if (child instanceof ViewportGraphics) {
        child.killTicker()
        child.destroy();
      }
    })
    menuGraphics.destroy();
  }
  const htmlOptions = document.getElementById('options');
  //repopulating
  if (settingValue(findSettingByID(46)) === 0) {
    menuGraphics = new MenuGraphics(app.stage)

    console.log("MAKING MENU GRAPHICS")
    menuGraphics.zIndex = 3;
    
    
    //select either .setting or .subtitle
    const divs = htmlOptions?.querySelectorAll('.setting, .subtitle');
    
    if (divs)
    divs.forEach(div=>{
      //create graphics object linked to div
      //alpha 1 for .setting, 0.8 for subtitle
      if (div.classList.contains('subtitle')) {
        new ViewportGraphics({destContainer: gearContainer, attachedHTML: div as HTMLElement, menuFade: true, alphaMult: 0.67})
      } else {
        new ViewportGraphics({destContainer: graphicsContainer, attachedHTML: div as HTMLElement, menuFade: true, alphaMult: 1})
      }
    })

    menuGraphics.updateOnce();
    
    htmlOptions?.classList.toggle("renderSettings", false);
  } else {
    htmlOptions?.classList.toggle("renderSettings", true);
  }

  
}


//resize function
export  function resizeCanvas() {

  mobileView = (window.innerWidth <= window.innerHeight)

  fixedWidth =  mobileView ? widthPortrait: widthLandscape;

  const scale = window.innerWidth / fixedWidth;
  
  aspectRatio = window.innerHeight / window.innerWidth
  const scaledHeight = fixedWidth * aspectRatio* scale;

  const resolution = window.devicePixelRatio * scale
  app.renderer.resize(fixedWidth, fixedWidth*aspectRatio) 
  app.renderer.resolution = resolution;
  
  // Set CSS size of the canvas
  app.canvas.style.width = `${Math.round(window.innerWidth)}px`;
  app.canvas.style.height = `${Math.round(scaledHeight)}px`;

  const options = document.querySelector(".options") as HTMLElement;
  options.classList.toggle("portrait", mobileView);

  console.log(1 / window.devicePixelRatio * scale)
  filter.resolution = Math.min(1,  resolution*scale)

  //set setting panel widths
  requestAnimationFrame(() => {
    setHeadingWidths();
  })
  
  for (const instance of viewportInstances) {
    if (!instance.position) continue;
    // instance.updateTextColour(true);
    instance.updatePos();
    instance.resize();
  }
// console.log('resize - fixedWidth:', fixedWidth, 'screen:', app.screen.width, app.screen.height, 'renderer:', app.renderer.width, app.renderer.height, 'stage children:', app.stage.children.length);
}

